import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  cornerRadiusL,
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  spaceXXL,
  scale110,
  xdlColorPremium,
  xdlColorPremiumTertiary,
  xdlColorBackground,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

const Container = styled.div`
  background-color: ${xdlColorPremiumTertiary};
  border-radius: ${cornerRadiusL};
  padding: 0 0 ${spaceXL} ${spaceXL};
  position: relative;
`;

const UnstyledButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: ${scale110};
  margin: 0;
  padding: 0;
  position: absolute;
  right: ${spaceS};
  top: ${spaceS};
  width: ${scale110};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${spaceXXL};

  @media ${mediaConfined} {
    flex-direction: row;
  }
`;

const VideoContainer = styled.div`
  flex: 1;
  margin-bottom: ${spaceXL};
  margin-right: ${spaceXL};
  max-width: 512px;

  @media ${mediaConfined} {
    margin-bottom: 0;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: ${spaceXL};
`;

const TopButton = styled(Button)`
  background-color: ${xdlColorPremium};
  color: ${xdlColorBackground};
  margin-bottom: ${spaceXXL};
  width: 100%;

  @media ${mediaConfined} {
    margin-bottom: 0;
    width: inherit;
  }
`;

const BottomContainer = styled.div`
  & a {
    display: flex;
    justify-content: flex-start;
    margin-bottom: ${spaceM};
  }
`;

const BottomContainerHeadline = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
`;

export const Styled = {
  Container,
  UnstyledButton,
  ContentContainer,
  VideoContainer,
  ActionsContainer,
  TopButton,
  BottomContainer,
  BottomContainerHeadline,
};
